export { EloTypeIcon } from './type-icon'
